import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { StoreModule } from '@ngrx/store';
import * as fromTransfersDeleted from './reducers/transfers-deleted.reducer';
import { EffectsModule } from '@ngrx/effects';
import { TransfersDeletedEffects } from './effects/transfers-deleted.effects';
import { TransfersDeletedComponent } from './transfers-deleted.component';
import { RouterModule } from '@angular/router';
import { TRANSFERS_DELETED_ROUTES } from './transfers-deleted.routes';
import { SmashDataTableModule } from '@app/shared/modules/smash-data-table/smash-data-table.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';

@NgModule({
  declarations: [TransfersDeletedComponent],
  imports: [
    CommonModule,
    SharedModule,
    SmashFormsModule,
    SmashDataTableModule,
    RouterModule.forChild(TRANSFERS_DELETED_ROUTES),
    StoreModule.forFeature(fromTransfersDeleted.transfersDeletedFeatureKey, fromTransfersDeleted.reducer),
    EffectsModule.forFeature([TransfersDeletedEffects]),
  ],
  exports: [TransfersDeletedComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TransfersDeletedModule { }
